// import history from 'src/lib/history';
import RestClient from '../../config/rest-client';
import processError from '../../lib/error';

export function getSlider(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.findOne('sliders', id)
      dispatch({
        type: 'SET_SLIDER',
        slider: data.slider,
        sliders: data.sliders,
      });
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function deleteSliderItems(ids) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      await RestClient.post('slider-item', 'delete', {ids})
      dispatch({type: 'DELETE_SLIDER_ITEMS', data: ids});
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function addSlideQuestions(ids, pr_id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.post('slider-item', 'question', {ids, pr_id})
      data.forEach(_i => {
        if(_i?.id){
          dispatch({type: 'ADD_SLIDER_SLIDER', data: _i})
        }
      });
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}



export async function getQuestions(where) {
  try {
    return await RestClient.post('questions/list', where)
  } catch (error) {
    throw new Error('ss');
  }
}



export async function getQuestionAnswer(session_id) {
  try {
    return await RestClient.findOne('slider/student/answers', session_id)
  } catch (error) {
    throw new Error('ss');
  }
}


export async function getStudentQuestion(session_id) {
  try {
    return await RestClient.findOne('slider/student/message', session_id)
  } catch (error) {
    throw new Error('ss');
  }
}

export function addSlideImages(images, pr_id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      // await RestClient.post('slider-item', 'delete', {ids})

      for (const file of images) {
        try {
          var bodyFormData = new FormData();
          bodyFormData.append("file", file.item);
          bodyFormData.append('pr_id', pr_id );

          const data = await RestClient.request({
            path: '/slider-item',
            method: 'POST',
            bodyJSObject: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
          })
          if(data[0] && data[0].id){
            dispatch({type: 'ADD_SLIDER_SLIDER', data: data[0]})
          }
        } catch (error) {
          console.log("🚀 ~ return ~ error:", error)
          
        }
      }
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function updateSliderItemOrder(order) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.post('slider-item', 'order', {order})
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function addSlidePdf(file, pr_id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})

      var bodyFormData = new FormData();
      bodyFormData.append("file", file);
      bodyFormData.append('pr_id', pr_id );

      const data = await RestClient.request({
        path: '/slider-item/pdf',
        method: 'POST',
        bodyJSObject: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data' }
      })
      if(data && Array.isArray(data)){
        data.forEach(item => {
          if(item && item.id){
            dispatch({type: 'ADD_SLIDER_SLIDER', data: item})
          }
        })
      }
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
    }
  };
}

export function addSlidePptx(file, pr_id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})

      var bodyFormData = new FormData();
      bodyFormData.append("file", file);
      bodyFormData.append('pr_id', pr_id );

      const data = await RestClient.request({
        path: '/slider-item/pptx',
        method: 'POST',
        bodyJSObject: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data' }
      })
      if(data && Array.isArray(data)){
        data.forEach(item => {
          if(item && item.id){
            dispatch({type: 'ADD_SLIDER_SLIDER', data: item})
          }
        })
      }
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
    }
  };
}

export function addSlideVideoFile(file, pr_id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})

      var bodyFormData = new FormData();
      bodyFormData.append("file", file);
      bodyFormData.append('pr_id', pr_id );

      const data = await RestClient.request({
        path: '/slider-item/video',
        method: 'POST',
        bodyJSObject: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data' }
      })
      if(data && data.id){
        dispatch({type: 'ADD_SLIDER_SLIDER', data: data})
      }
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js: ~ return ~ error:", error)
      throw new Error('ss');
    }
  };
}

export function addSlideVideoLink(src, pr_id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.post('slider-item', 'video-link', { src, pr_id })
      if(data && data.id){
        dispatch({type: 'ADD_SLIDER_SLIDER', data: data})
      }
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
    } catch (error) {
      dispatch({type: 'SET_SLIDERS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js: ~ return ~ error:", error)
      throw new Error('ss');
    }
  };
}